import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import PhotoPermissionsUtil from '../../../helpers/permissions/PhotoPermissionsUtil';
import fileTypeImageIcon from '../../../assets/images/photo-jpg-placeholder.svg';
import fileTypeNoImageRequired from '../../../assets/images/na-photo.svg';
import TaskCompletionStepPhotoGrid from './TaskCompletionStepPhotoGrid';
import StepApproval from '../StepApproval';
import TaskCompletionStepComments from '../TaskCompletionStepComments';
import CommentPopup from '../CommentPopup';
import FileUploadPreview from './FileUploadPreview/';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import dataModel from '../../../models/DataModel';
import MiscConstants from '../../../constants/MiscConstants';
import WaitSpinner from '../../../components/WaitSpinner';
import PhotoUtil from '../../../helpers/PhotoUtil/PhotoUtil';
import PhotoUtilPlugin from '../../../helpers/PhotoUtilPlugin/PhotoUtilPlugin';
import CompletionStepUtil from '../../../helpers/CompletionStepUtil/CompletionStepUtil';
import Animate from '../../../components/Animate';
import './PhotoUpload.scss';
import Textarea from '../../Textarea';

// TODO: this component is duplicated - collapse into 1

export class PhotoUpload extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      stepState: '',
      userCanModify: false,
      naButton: true,
      loadingImage: false,
      uploadInProgress: false,
      previewFile: null,
      send: false,
      showKeyboard: true,
    };
    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
    this.attachmentId = 0;

    this.toggleLoading = this.toggleLoading.bind(this);
    this.handleUploadConfirm = this.handleUploadConfirm.bind(this);
    this.handleUploadCancel = this.handleUploadCancel.bind(this);
    this.handleOnButtonClick = this.handleOnButtonClick.bind(this);

    this.attachmentCount = props.completionStep.attachments ? props.completionStep.attachments.length : 0;
  }

  componentDidMount() {
    this.checkForNA();
    this.setState({ uploadImageId: null, completionStep: this.props.completionStep });
    // register for speech detection
    dataModel.mobileBridge.addSpeechDetectedObserver(this.handleSpeechDetected);
  }

  componentDidUpdate(prevProps) {
    //reset attachmentCount on completion step update
    if (prevProps.completionStep != this.props.completionStep) {
      this.setState({ uploadInProgress: false, uploadImageId: null, completionStep: this.props.completionStep });
    }
    if (prevProps.completionStep.attachments && this.props.completionStep.attachments && prevProps.completionStep.attachments.length != this.props.completionStep.attachments.length) {
      this.attachmentCount = this.props.completionStep.attachments.length;
    }
    
    if (
      prevProps.completionStep != this.props.completionStep ||
      prevProps.completionStep.not_applicable != this.props.completionStep.not_applicable ||
      prevProps.completionStep.completed_at != this.props.completionStep.completed_at ||
      prevProps.isFieldUser != this.props.isFieldUser ||
      prevProps.userStepPermissions.size != this.props.userStepPermissions.size
    ) {
      this.setState({ completionStep: this.props.completionStep });
      this.checkForNA();
    }
  }

  componentWillUnmount() {
    //unregister for speech detection
    dataModel.mobileBridge.removeSpeechDetectedObserver(this.handleSpeechDetected);
  }

  checkForNA() {
    const completionStep = this.state.completionStep ? this.state.completionStep : this.props.completionStep;
    const { userStepPermissions } = this.props;
    if (
      !completionStep.not_applicable &&
      userStepPermissions &&
      userStepPermissions.has('step_complete') &&
      !completionStep.completed_at
    ) {
      this.setState({ naButton: true });
    } else {
      this.setState({ naButton: false });
    }
  }

  async handleMultipleFileSelection(e) {
    e.preventDefault();

    const { completionStep } = this.state;
    const { task } = this.props;

    const files = e.target.files;

    if (!files.length) {
      return;
    }
    else {
      this.toggleLoading();
      const updatedCS = await PhotoUtil.selectMultipleFiles(files, true, completionStep, task);
      if (updatedCS) {
        updatedCS.completed_at = new Date().toJSON();
        if (this.props.handleChildCompletionStepUpdate) {
          this.props.handleChildCompletionStepUpdate(updatedCS);
        }
    
        this.setState({ completionStep: updatedCS });
      }
      this.toggleLoading();
    }
  }

  async toggleLoading() {
    this.setState({ loadingImage: !this.state.loadingImage });
  }

  handleNoPhotoRequiredButton() {
    const { completionStep } = this.state;
    completionStep.not_applicable = true;
    completionStep.completed_at = new Date().toJSON();
    this.analyticsLogger.logNotApplicable('jpg');
    dataModel.completionCriteriaDAO.markNotApplicable(completionStep).then(cs => {
      const foundCS = dataModel.completionCriteriaDAO.findItem(this.state.completionStep.id);
      if(foundCS) {
        if (this.props.handleChildCompletionStepUpdate) {
          this.props.handleChildCompletionStepUpdate(foundCS);
        }
      }
    });
  }

  handleUndoNotApplicable() {
    const clonedStep = { ...this.props.completionStep };
    clonedStep.not_applicable = null;
    clonedStep.completed_at = null;
    CompletionStepUtil.handleCSUndoNotApplicableButton(clonedStep, this.analyticsLogger).then(cs => {
      const foundCS = dataModel.completionCriteriaDAO.findItem(this.state.completionStep.id);
      if (foundCS) {
        if (this.props.handleChildCompletionStepUpdate) {
          this.props.handleChildCompletionStepUpdate(foundCS);
        }
      }
    });
  }

  handleKeyDown(e, type) {
    if (e.keyCode == 27) {
      this.setState({ noPhotoRequiredComment: false, rejectionComment: false });
    } else if (e.keyCode == 13 || e.keyCode == 40) {
      // e.preventDefault();
      // this.handleCommentSent(type, this.state.commentText)
      this.setState({ rejectionComment: true ,noPhotoRequiredComment: true });
      this.state.showKeyboard=false;
      this.setFocus(e.target,e);
    }
  }

  handleRejectionKeyDown(e) {
    if (e.keyCode == 27) {
      this.setState({ noPhotoRequiredComment: false, rejectionComment: false });
    } 
    else if (e.keyCode == 13 || e.keyCode == 40) {
      this.setState({ rejectionComment: true ,noPhotoRequiredComment: true });
      this.state.showKeyboard=false;
      this.setFocus(e.target,e);
    }
  }

  handleOnButtonClick(){
    this.state.send=true;
    if(this.state.commentText){
      this.handleCommentSent('reject', this.state.commentText);
    }
  }

  handleCancelComment() {
    this.setState({
      noPhotoRequiredComment: false,
      rejectionComment: false,
    });
    this.checkForNA();
  }

  handleCommentSent(type, commentText) {
    this.setState({ noPhotoRequiredComment: false, rejectionComment: false });
    const { completionStep } = this.state;
    const { task } = this.props;

    CompletionStepUtil.handleRejected(this.props.currentUser, task, completionStep, type, commentText, this.analyticsLogger).then(rejectedCompletionStep => {
      this.setState({ commentText: '' });

      if (this.commentInput) {
        this.commentInput.blur();
      }
  
      if (rejectedCompletionStep) {
        if (this.props.mobileBridge.isMobile) {
          this.props.history.goBack();
        }
        else {
          this.setState({ completionStep: rejectedCompletionStep });
        }
      }
    });
  }

  handleCommentChange(e) {
    if(e.target.value.trim()!=''){
      this.setState({ commentText: e.target.value });
    }
    else{
      this.setState({ commentText: '' });
    }
  }

  handleStepApprove() {
    const { userStepPermissions } = this.props;
    const { completionStep } = this.state;
    if (userStepPermissions.has('is_approver')) {
      this.handleApproved(completionStep);
    }
    else if (userStepPermissions.has('is_reviewer')) {
      this.handleReviewed(completionStep);
    }
  }

  handleStepReject() {
    const { task } = this.props;
    if ((task.has_reviewer && this.state.completionStep.reviewed_at) || !task.has_reviewer) {
      this.handleRejectApproval(this.state.completionStep);
    }
    else {
      this.handleRejectReview(this.state.completionStep);
    }
  }

  handlePhotoSelection(val) {
    this.setState({ photoSelected: val });
  }

  handleReviewed(completionStep) {
    completionStep.reviewed_at = new Date().toJSON();
    dataModel.completionCriteriaDAO.reviewCompletionCriterion(completionStep).then(response => {
      const foundCS = dataModel.completionCriteriaDAO.findItem(this.state.completionStep.id);
      if (foundCS) {
        if (this.props.handleChildCompletionStepUpdate) {
          this.props.handleChildCompletionStepUpdate(foundCS);
        }
      }
      this.analyticsLogger.logReviewEvent();
      if (this.props.mobileBridge.isMobile) {
        this.props.history.goBack();
      }
    });
  }

  handleRejectReview() {
    this.setState({ rejectionComment: true });
  }

  async handleApproved(completionStep) {
    if (completionStep) {
      completionStep.task_id = this.props.task.id;
      completionStep.approved_at = new Date().toJSON();
      await dataModel.completionCriteriaDAO.approveCompletionCriterion(completionStep);
      this.analyticsLogger.logApprovalEvent();

      const foundCS = dataModel.completionCriteriaDAO.findItem(this.state.completionStep.id);
      if (foundCS) {
        if (this.props.handleChildCompletionStepUpdate) {
          this.props.handleChildCompletionStepUpdate(foundCS);
        }
      }

      if (this.state.uploadComment) {
        const comment = {
          caption: 'Completion Step Approved',
          body: this.state.uploadComment,
          commentable_type: 'CompletionCriterion',
          commentable_id: completionStep.id,
          user_id: this.props.currentUser.id,
        };
        await dataModel.commentsDAO.createComment(comment, false, null, { recordDescriptor: { comments: {} } });
        this.setState({ uploadComment: '' });
      }
      if (this.props.mobileBridge.isMobile) {
        this.props.history.goBack();
      }
    }
  }

  handleRejectApproval(completionStep) {
    this.setState({ rejectionComment: true });
  }

  setFocus(element,e) {
    if (element && e==null && this.state.showKeyboard) {
      this.commentInput = element;
      this.commentInput.focus(); 
    }  
    else if(e && element && !this.state.showKeyboard){
      this.commentInput = element;
      this.commentInput.blur();   
    }
  }

  handleDetermineRejected(task){
    const stepsRejected = task.completion_criteria
    ? task.completion_criteria.filter(cc => {
      if (cc) {
        return (
          cc.rejected_at &&
          !cc.approved_at &&
          !cc.reviewed_at &&
          !cc.completed_at
        );
      }
      else {
        return false;
      }
    }
    )
    : [];
    return stepsRejected.length > 0;
  }

  handleSpeechDetected(speechText) {
    const speechDataLowerWithoutSpaces = speechText.replace(/ /g, '').toLowerCase();
    const { task, userStepPermissions } = this.props;
    const { completionStep } = this.state;

    if (
      speechDataLowerWithoutSpaces.includes('camera') ||
      speechDataLowerWithoutSpaces.includes('photo') ||
      speechDataLowerWithoutSpaces.includes('picture')
    ) {
      if (task && completionStep && userStepPermissions && PhotoPermissionsUtil.canUserEditPhoto(userStepPermissions, completionStep, task)) {
        this.handleMobileImage('camera', true);
      }
    }
    else {
      setTimeout(() => {
        dataModel.showGlobalModal('HANDSFREE_ERROR_MODAL', {
          message: 'Hint: try saying take a photo',
        });
      }, 2500);
    }
  }

  handleAddButton() {
    this.setState({ displayUploadButtons: true });
  }

  handleMobileImageEvent(e) {
    e.preventDefault();
    const uploadMethod = e.target.name;
    this.handleMobileImage(uploadMethod, false);
  }

  handleMobileImage(uploadMethod, handsFree) {
    if (navigator && navigator.camera) {
      dataModel.mobileBridge.removeSpeechDetectedObserver(this.handleSpeechDetected);
      this.handleCancelButton();
      this.setState({ uploadMethod }, () => {
        PhotoUtilPlugin.captureMobileImage(uploadMethod, handsFree, () => {
          this.toggleLoading();
        })
        .then((fileinfo) => {
          // preview if photo selected from library or hands free camera
          fileinfo.handsFree = handsFree;
          if (uploadMethod == 'library' || handsFree) {
            if (!fileinfo.type) {
              fileinfo.type = 'image';
            }
            this.setState({ previewFile: fileinfo });
          } else {
            this.finishUpload(fileinfo);
          }
        })
        .catch((error) => {
          if (this.state.loadingImage) {
            this.toggleLoading();
          }
        });
      });
    }
  }

  handleCloseUpLoadButtons() {
    this.setState({ displayUploadButtons: false, hideUploadButtons: false });
  }

  finishUpload(fileinfo) {

    // for (let i = 0; i < fileinfo.length; i++) {
    
     // const { file, fileExtension, resizedImage, exifData, handsFree } = fileinfo[i]
    const { file, fileExtension, resizedImage, exifData, handsFree } = fileinfo;
    const { task, switchCS, handleHandsFreeTaskComplete } = this.props;
    const { completionStep } = this.state;
    dataModel.mobileBridge.addSpeechDetectedObserver(this.handleSpeechDetected);
    PhotoUtilPlugin.handleSaveFile(file, fileExtension, resizedImage, exifData, completionStep, task)
        .then((updatedStep) => {

            // alert(JSON.stringify(fileinfo.length))
            // alert(JSON.stringify(i+1))
           // this.toggleLoading()
            // if(fileinfo.length == i+1) {  //NEW library
            //   //alert(i)
            //   this.toggleLoading()
            //   this.setState({ previewFile: null, completionStep: updatedStep })
            // }
          this.toggleLoading();
          this.setState({ previewFile: null, completionStep: updatedStep });
          if (handsFree) {
            setTimeout(() => {
              const { completed, total } = task.completion_criteria_counts;
              if (total - completed <= 1) {
                if (handleHandsFreeTaskComplete) {
                  handleHandsFreeTaskComplete();
                }
              }
              else {
                if (switchCS) {
                  switchCS(true);
                }
              }
            }, 2000);
          }
          
        })
        .catch((error) => {
          if (this.state.loadingImage) {
            this.toggleLoading();
          }
        });
    // }
  
  }

  handleUploadConfirm() {
    this.finishUpload(this.state.previewFile);
  }

  handleUploadCancel() {
    dataModel.mobileBridge.addSpeechDetectedObserver(this.handleSpeechDetected);
    this.toggleLoading();
    this.setState({ previewFile: null, uploadMethod: null });
  }
  
  handleCancelButton() {
    this.setState({
      hideUploadButtons: true,
    });
  }

  render() {
    const { 
      editing, 
      task,
      userStepPermissions, 
    } = this.props;

    const {
      completionStep,
      loadingImage,
    } = this.state;

    if (!completionStep) {
      return null;
    }

    let buttons = [];

    let reviewApproveButtons = null;
    if (!editing && !this.state.rejectionComment &&
        userStepPermissions &&
      userStepPermissions.has('accept/reject') && !completionStep.rejected_at) {
      reviewApproveButtons = (
        <div className={'photo-approve-reject-buttons' + (completionStep.not_applicable ? ' na' : '')}>
          <StepApproval key={(task.has_reviewer && (userStepPermissions.has('is_reviewer') || this.props.currentUser.super_admin) &&
            !completionStep.reviewed_at ? '_review' : '_approve') + completionStep.id} userStepPermissions={userStepPermissions}
            handleStepReject={this.handleStepReject}
            handleStepApprove={this.handleStepApprove}
          />
        </div>
      );
    }

    let typeImage = null;
    let gridDisplayed = false;
    if (completionStep.not_applicable) {
      typeImage = (
        <img
          className="photo-default-image-display"
          src={fileTypeNoImageRequired}
          alt="not applicable"
          data-qa="not-applicable-image"
        />
      );
    } else if ((completionStep.attachments && completionStep.attachments.length) || this.state.uploadInProgress) {
      gridDisplayed = true;

      typeImage = (
        <TaskCompletionStepPhotoGrid
          completionStep={completionStep}
          task={task}
          attachments={completionStep.attachments}
          uploadInProgress={this.state.uploadInProgress}
          uploadImageId={this.state.uploadImageId}
          withAcceptReject={reviewApproveButtons ? true : false}
          userStepPermissions={this.props.userStepPermissions}
          completionStepStatus={this.props.completionStepStatus}
        />
      );
    } else if (!editing) {
      typeImage = (
        <img
          className="photo-default-image-display"  
          alt=""
          src={fileTypeImageIcon}
        />
      );
    }

    let buttonList;
    if (!editing) {

      if (this.props.mobileBridge.isMobile) {
        buttons.push(
          <div
            className="button comments-button"
            onClick={this.props.handleCommentsButton}
            key="comment-button"
          >
            {completionStep.comments && completionStep.comments.length > 0 ? (
              <div className="indicator-dot" />
            ) : null}
          </div>
        );
      }
      if (this.state.naButton) {
        buttons.push(
          <div
            className="button na-button"
            key="no-image-button"
            onClick={this.handleNoPhotoRequiredButton}
            data-qa="not-applicable-button"
          />
        );
      }
      if (
        completionStep.not_applicable && 
        (userStepPermissions.has('step_complete') || userStepPermissions.has('step_update')) && 
        !completionStep.reviewed_at && !completionStep.approved_at &&
        completionStep.status != 'completed'
      ) {
        buttons.push(
          <div
            className="button undo-na-button"
            key="undo-na-button"
            onClick={this.handleUndoNotApplicable}
            data-qa="not-applicable-button"
          />
        );
      }
      if (
        !editing &&
        !completionStep.not_applicable &&
        userStepPermissions &&
        PhotoPermissionsUtil.canUserEditPhoto(userStepPermissions, completionStep, task) &&
        (!completionStep.attachments ||
          Math.max(this.attachmentCount, completionStep.attachments.length) < MiscConstants.MAX_NUMBER_OF_PHOTOS)
      ) {
        if (!!window.cordova) {
          buttons.push(<div className="button add-button" onClick={this.handleAddButton} key="add-button" />);
        } else {
          buttons.push(
            <label htmlFor="imageUpload" className="button add-button" key="add-button">
              <input id="imageUpload" type="file" onChange={this.handleMultipleFileSelection} accept="image/*" multiple />
            </label>
          );
        }
      }

      buttonList = (
        <div
          className={`photo-button-list ${
            !this.props.mobileBridge.isMobile && completionStep.attachments && completionStep.attachments.length > 1 ? 'grid-expand ' : ''
          }
          ${
            (completionStep.attachments && completionStep.attachments.length) == 1 ? 'single-photo' : ''
          }
          ${
            userStepPermissions && userStepPermissions.has('accept/reject') ? 'review-approve' : ''
          }`}
        >
          {buttons}
        </div>
      );
    }

    let displayComponent = typeImage;

    let commentDisplay = null;
    let background = null;
    let sendButton = (
      <div className="send-button disabled">
        <div className="send-text disabled">SEND</div>
      </div>
    );
    if (this.state.commentText && this.state.commentText!='') {
      sendButton = (
        <div className="send-button" onClick={this.handleOnButtonClick}>
          <div className="send-text">SEND</div>
        </div>
      );
    }
    if (!editing) {
      if (this.state.noPhotoRequiredComment) {
        buttonList = null;
        if (this.props.mobileBridge.isMobile) {
          background = <div className="photo-background-disable" onClick={this.handleCancelComment} onTouchStart={this.handleCancelComment}/>;
          commentDisplay = (
            <div
              className="photo-comment-input"
            >
              <Textarea
                rows={3}
                className="text-input"
                placeholder="Leave a comment to mark as N/A."
                ref={element => {
                  this.setFocus(element,null);
                }}
                onChange={this.handleCommentChange}
                value={this.state.commentText}
                onKeyDown={e => this.handleKeyDown(e, 'na')}
                dataId={completionStep.id}
              />
               {sendButton}
            </div>
          );
        } else {
          const element = document.getElementById(
            'task-completion-step-comments-' + completionStep.id
          );
          const rect = element.getBoundingClientRect();
          commentDisplay = (
            <CommentPopup
              task={task}
              completionStep={completionStep}
              height={element.clientHeight}
              width={element.clientWidth}
              left={rect.left}
              top={rect.top - 20}
              type={'NO PHOTO REQUIRED'}
              commentSent={commentText =>
                this.handleCommentSent('na', commentText)
              }
              placeholder={
                'Leave a comment to mark as N/A.'
              }
              cancelComment={this.handleCancelComment}
            />
          );
        }
      } else if (this.state.rejectionComment) {
        buttonList = null;
        if (this.props.mobileBridge.isMobile) {
          background = <div className="photo-background-disable" onClick={this.handleCancelComment} onTouchStart={this.handleCancelComment}/>;
          commentDisplay = (
            <div className="photo-comment-input">
              <Textarea
                ref={element => {
                  this.setFocus(element,null);
                }}
                rows={3}
                className="text-input"
                placeholder="You must leave a comment to reject a Completion Step."
                onChange={this.handleCommentChange}
                value={this.state.commentText}
                onKeyDown={e => this.handleRejectionKeyDown(e)}
                dataId={completionStep.id}
              />
              {sendButton}
            </div>
          );
        } else {
          const element = document.getElementById(
            'task-completion-step-comments-' + completionStep.id
          );
          const rect = element.getBoundingClientRect();
          commentDisplay = (
            <CommentPopup
              task={task}
              completionStep={completionStep}
              height={element.clientHeight}
              width={element.clientWidth}
              left={rect.left}
              top={rect.top - 20}
              type={'REJECTED'}
              commentSent={commentText =>
                this.handleCommentSent('reject', commentText)
              }
              placeholder={
                'You must leave a comment to reject a Completion Step.'
              }
              cancelComment={this.handleCancelComment}
            />
          );
        }
      }
    }

    if (this.state.photoSelected) {
      buttonList = null;
    }

    let comments = null;
    if (!this.props.mobileBridge.isMobile && !editing) {
      comments = (
        <TaskCompletionStepComments
          id={'task-completion-step-comments-' + completionStep.id}
          task={task}
          completionStep={completionStep}
        />
      );
    }

    let uploadButtons = null;
    let animate = null;
    if (this.state.displayUploadButtons && !editing) {
      buttonList = null;
      background = <div className="photo-background-disable" onClick={this.handleCancelComment}/>;

      animate = (
        <Animate
          component_id="upload-buttons"
          key="upload-buttons"
          property={{ bottom: { startVal: -213, endVal: 20 } }}
          duration={250}
        />
      );
      
      uploadButtons = (
        <div className="upload-options" id="upload-buttons">
          <div className="outerbox">
            <button name="library" ref="library" className="upload-button top-button" onClick={this.handleMobileImageEvent}>Upload File</button>
            <button name="camera" onClick={this.handleMobileImageEvent} className="upload-button">Use Camera</button>
          </div>
          <div className="cancel-button" onClick={this.handleCancelButton}>
            Cancel
          </div>
        </div>
      );
    }
    if (this.state.hideUploadButtons) {
      animate = (
        <Animate
          component_id="upload-buttons"
          key="upload-buttons_hide"
          property={{ bottom: { startVal: 20, endVal: -213 } }}
          duration={250}
          completionCallback={this.handleCloseUpLoadButtons}
        />
      );
    }
    // if(this.state.previewFile==null && loadingImage){
    //   dataModel.mobileBridge.addSpeechDetectedObserver(this.handleSpeechDetected)
    //   this.toggleLoading()
    //   this.setState({ previewFile: null, uploadMethod: null,loadingImage:false })
    //   }
    console.log('this.state.previewFile',this.state.previewFile);
    return (
      <div
        className="photo-upload-step"
        id={'photo-upload-step-' + completionStep.id}
      >
        { loadingImage && <div className='loading'><WaitSpinner /></div> }
        {animate}
        {background}
        <div className={'display-and-buttons ' + (gridDisplayed ? 'grid-displayed' : '')}>
          {!this.props.mobileBridge.isMobile &&
            completionStep.instructions && (
              <div className="photo-instructions">
                <div className="instruction-label">Instructions</div>
                <div className="instruction-text">
                  {completionStep.instructions}
                </div>
              </div>
            )}
          {displayComponent}
          {buttonList}
        </div>
        {this.state.previewFile &&
          <FileUploadPreview
            fileToPreview={this.state.previewFile}
            handleUploadConfirm={this.handleUploadConfirm}
            handleUploadCancel={this.handleUploadCancel}
          />
        }
        {commentDisplay}
        {uploadButtons}
        {reviewApproveButtons}
        {comments}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    inProgress: state.main.inProgress,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
    mobileBridge: dataModel.mobileBridge,
  };
};

// For handling state change from a dispatch
export default connect(mapStateToProps, null)(withRouter(PhotoUpload));



// WEBPACK FOOTER //
// ./src/components/TaskCompletionStepsMobile/PhotoUpload/index.js